
























































import Vue from 'vue';
import Component from 'vue-class-component';
import MyInfo from './employee/MyInfo.vue';
import { labelAdminApis, LabelInfo, SiteInfo } from '@/api/label.api';
import LabelEditDialog from '@/views/navigation/LabelEditDialog.vue';
import { Ref } from 'vue-property-decorator';

@Component({ components: { MyInfo, LabelEditDialog } })
export default class Home extends Vue {
  @Ref('label-edit-dialog') labelEditDialog!: LabelEditDialog;
  defaultActive = '0';
  labelList: Array<LabelInfo> | null = null;
  siteList: Array<SiteInfo> | null = null;
  label_loading = false;
  site_loading = false;

  created() {
    this.watch_active_index(0);
  }

  async mounted() {
    this.label_loading = true;
    this.labelList = await labelAdminApis.listLabels();
    this.label_loading = false;
  }

  new_tab(address: string) {
    if (address) {
      if (address.slice(0, 4) == 'http') {
        window.open(address);
      } else {
        window.open('http://' + address);
      }
    } else {
      this.$notify.error(`请联系站点管理员配置正确的站点地址`);
    }
  }

  addLabel() {
    this.labelEditDialog.show(null);
  }

  addLabelList(label: LabelInfo) {
    if (this.labelList) {
      this.labelList.push(label);
    } else {
      this.watch_active_index(0);
    }
  }

  async watch_active_index(index: number) {
    this.site_loading = true;
    this.siteList = await labelAdminApis.listLabelSites(index);
    this.site_loading = false;
  }

  async delLabel(label_id: number) {
    this.label_loading = true;
    await labelAdminApis.delLabel(label_id);
    this.labelList = await labelAdminApis.listLabels();
    this.watch_active_index(0);
    this.label_loading = false;
  }
}
